import {
  OfferElementDetailsTranslation,
  offerElementDetailsTranslation,
} from '@/assets/locales/views/offerElements/details/offerElementDetails.translation.pl.ts';
import {
  offerElementEditorTranslation,
  OfferElementEditorTranslation,
} from '@/assets/locales/views/offerElements/editor/offerElementEditor.translation.pl.ts';
import {
  offerElementsListTranslation,
  OfferElementsListTranslation,
} from '@/assets/locales/views/offerElements/list/offerElementsList.translation.pl.ts';

export type OfferElementsTranslation = {
  details: OfferElementDetailsTranslation;
  editor: OfferElementEditorTranslation;
  list: OfferElementsListTranslation;
};

export const offerElementsTranslation: OfferElementsTranslation = {
  details: offerElementDetailsTranslation,
  editor: offerElementEditorTranslation,
  list: offerElementsListTranslation,
};
